module.exports = "/assets/dist/images/slider-dot.png?d215cbce0d475801b1d9f4c069aa48c5";